import { selectWarehouse } from 'containers/Warehouses/warehousesSlice'
import useAccessSettingActions from '../hooks/useAccessSettingActions'
import useTranslation from 'hooks/useTranslation'
import usePopupState from 'hooks/usePopupState'
import Switch from 'components/inputs/Switch'
import { useParams } from 'react-router-dom'
import { useReduxSelector } from 'store'
import PinPopup from './PinPopup'

const AccessSettings = () => {
  const { id } = useParams<warehouse.PageParams>()
  const warehouse = useReduxSelector(state => selectWarehouse(state, id))

  const { t } = useTranslation('warehouse')
  const { popup, openPopup } = usePopupState()
  const { isSending, action } = useAccessSettingActions()

  return (
    <>
      {popup === 'pin' && <div>
        <PinPopup
          selected={warehouse?.['2fa_access']?.customPinSecured}
        />
      </div>}

      <p>{t('securitySettings')}</p>
      <div className='menu__additionalAccess'>
        <hr />
        {warehouse?.['2fa_access']?.biometricsSecured !== undefined && <div className='menu__additionalAccess__item'>
          <div className='menu__additionalAccess__item__icon'>
            <i className='icon icon--fingerprint s24' />
          </div>
          <div className='menu__additionalAccess__item__desc'>
            <div>{t('biometrics')}</div>
            <div>{t('openWithBiometrics')}</div>
          </div>
          <Switch
            name='biometric'
            disabled={isSending}
            checked={warehouse?.['2fa_access']?.biometricsSecured}
            changeHandler={() => {
              action({ biometricsSecured: !warehouse['2fa_access']?.biometricsSecured })
            }} />
        </div>}
        <hr />

        {warehouse?.['2fa_access']?.applicationPinSecured !== undefined && <div className='menu__additionalAccess__item'>
          <div className='menu__additionalAccess__item__icon'>
            <i className='icon icon--pin s24' />
          </div>
          <div className='menu__additionalAccess__item__desc'>
            <div>{t('applicationPin')}</div>
            <div>{t('authorizationUsingCurrentPin')}</div>
          </div>
          <Switch
            name='app_pin'
            disabled={isSending}
            checked={warehouse?.['2fa_access']?.applicationPinSecured}
            changeHandler={() => {
              action({ applicationPinSecured: !warehouse['2fa_access']?.applicationPinSecured })
            }} />
        </div>}
        <hr />

        {warehouse?.['2fa_access']?.customPinSecured !== undefined && <div className='menu__additionalAccess__item'>
          <div className='menu__additionalAccess__item__icon'>
            <i className='icon icon--pin s24' />
          </div>
          <div className='menu__additionalAccess__item__desc'>
            <div>{t('newPin')}</div>
            <div>{t('enterNewPinForAuthorization')}</div>
          </div>
          <Switch
            name='custom_pin'
            disabled={isSending}
            checked={warehouse?.['2fa_access']?.customPinSecured}
            changeHandler={() => {
              if (warehouse?.['2fa_access']?.customPinSecured) {
                action({ customPin: false })
              } else {
                openPopup('pin')
              }
            }} />
        </div>}
        <hr />
      </div>
    </>
  )
}

export default AccessSettings